import {
  getLocalStorageItem,
  isCopanySuperOrSubAdmin,
  isSuperAndSubAdmin,
  useOutsideClick
} from '../../../utils/helper';
import React from 'react';
import { useRef, useState, useEffect } from 'react';
import { Calendar } from 'react-date-range';
import SearchInput from '../../../component/common/Input/SearchInput';
import { Helmet } from 'react-helmet';
import { ChevronRightIcon, ChevronLeftIcon } from '@heroicons/react/20/solid';
import { Link, useNavigate } from 'react-router-dom';
import Loader from '../../../component/common/Loader';
import Topbar2 from '../../PulseSurvey/Topbar';
import { StatCard, STAT_ICONS } from '../../../component/common/designSystem';
import ChallengesCard from '../../../component/common/cards/ChallengesCard.jsx';
import { ApiForRole } from './ApiForRole.js';
import { Api } from '../../../api/index.js';

function Challenges() {
  const selectedTheme = JSON.parse(localStorage.getItem('selectedTheme'));
  const userData = getLocalStorageItem('userData') && JSON.parse(getLocalStorageItem('userData'));
  const ref2 = useRef(null);
  const calendarRef = useRef(null);
  const [isOpen2, setIsOpen2] = useState(false);
  const [startDate, setStartDate] = useState();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [debounceTimeout, setDebounceTimeout] = useState(null);
    const [loader, setLoader] = useState(false);
  const [challengesList, setChallengesList] = useState({
    stats: {
      activeChallengesCount: 0,
      totalChallengesCount: 0,
      totalTasksInChallenges: 0
    },
    activeChallenges: [],
    allTemplates: [],
    allChallenges: []
  });

  const handleChangeC = (e) => {
    const date = new Date(e);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    setStartDate(formattedDate);
    setIsOpen2(false);
  };

  useOutsideClick(calendarRef, () => {
    setIsOpen2(false);
  });

  const subAdminStatusCards = [
    <StatCard
      icon={STAT_ICONS.onlineNow}
      title={'Active Challenges'}
      value={challengesList?.stats?.activeChallengesCount || 0}
    />,
    <StatCard
      icon={STAT_ICONS.completions}
      title={'Total Challenges'}
      value={challengesList?.stats?.totalChallengesCount || 0}
    />,
    <StatCard
      icon={STAT_ICONS.goals}
      title={'Created Tasks'}
      value={challengesList?.stats?.totalTasksInChallenges || 0}
    />
  ];

  const B2BAdminStatusCards = [
    <StatCard
      icon={STAT_ICONS.revenue}
      title={'Total Wellpoints'}
      value={challengesList?.stats?.totalWellpoint || 0}
    />,
    <StatCard
      icon={STAT_ICONS.onlineNow}
      title={'Active Challenges'}
      value={challengesList?.stats?.activeChallengesCount || 0}
    />,
    <StatCard
      icon={STAT_ICONS.completions}
      title={'Total Challenges'}
      value={challengesList?.stats?.totalChallengesCount || 0}
    />,
    <StatCard
      icon={STAT_ICONS.goals}
      title={'Standalone Tasks'}
      value={challengesList?.stats?.totalTasksInChallenges || 0}
    />
  ];



  const fetchChallenges = async () => {
    setLoader(true);
    try {
       const response = await ApiForRole().getChallenges(startDate, searchTerm)
        const responseData = response?.data || {};
        if (responseData) {
          setChallengesList(responseData);
          localStorage.removeItem("challengeStatus")
        }
    } catch (error) {
      console.error('Error fetching get Challenges:', error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (searchTerm) {
      const delayDebounceFn = setTimeout(() => {
       fetchChallenges();
      }, 800);

      return () => clearTimeout(delayDebounceFn);
    }
    if(startDate){
      fetchChallenges();
    }
    else{
      fetchChallenges();
    }
  }, [startDate, searchTerm]);

  return (
    <>
      <div className="relative lg:ps-5 lg:mb-[45px]">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Challenges | Shoorah Admin</title>
        </Helmet>
        {loader ? <Loader /> : null}
        <Topbar2 title={'Challenges'} infoBtn={false} />
      </div>

      <div className="relative lg:mb-[45px]">
        {/*search options, Date filter & Add Company are here */}
        <div className="sm:flex flex-col md:flex-row justify-between items-center gap-3">
          {/* Left-aligned search input */}
          <div className="flex items-center justify-start sm:justify-center w-full sm:w-auto">
            <SearchInput
              id="searchKey"
              name="searchKey"
              type="text"
              onChange={(e) => {
                setSearchTerm(e.target.value);
                if (debounceTimeout) clearTimeout(debounceTimeout);
                const timeout = setTimeout(() => {
                }, 500);
                setDebounceTimeout(timeout);
              }}
              placeholder="Search"
              className="w-full sm:w-auto px-3 py-2"
            />
          </div>

          {/* Right-aligned buttons */}
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-center mt-2 sm:mt-0 space-y-2 sm:space-y-0 sm:space-x-2 w-full sm:w-auto">
            <div ref={ref2} className="relative inline-block text-left w-full sm:w-auto">
              <button
                type="button"
                onClick={() => setIsOpen2(!isOpen2)}
                className="flex justify-between items-center w-full sm:w-auto px-5 py-2 text-xs sm:text-base font-medium border dark:border-text-shoorah-darkBg border-[#0B1D2E] rounded-full dark:text-shoorah-darkBg dark:border-shoorah-darkBg"
              >
                <span>
                  {startDate ? `${new Date(startDate).toLocaleDateString()}` : 'Date Created'}
                </span>
                {selectedTheme ? (
                  <>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17.2802 9.9668L12.9335 14.3135C12.4202 14.8268 11.5802 14.8268 11.0669 14.3135L6.72021 9.9668"
                        stroke="#F3F4F6"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </>
                ) : (
                  <>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17.2802 9.9668L12.9335 14.3135C12.4202 14.8268 11.5802 14.8268 11.0669 14.3135L6.72021 9.9668"
                        stroke="#0B1D2E"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </>
                )}
              </button>
              {isOpen2 && (
                <div
                  className="absolute sm:-top-2 top-0 md:-left-40 sm:-left-10 left-0 w-full sm:w-auto transform scale-90 sm:scale-100 z-10 mt-1 p-2 bg-white shadow-lg ring-1 ring-[#E7EAE8] dark:bg-shoorah-darkBgColor rounded-md"
                  ref={calendarRef}
                >
                  <div className="bg-white dark:bg-shoorah-darkBgColor text-[14px]">
                    <Calendar
                      className={'calendar text-sm sm:text-lg'}
                      onChange={handleChangeC}
                      nextLabel={
                        <button className="custom-next-button flex justify-center items-center">
                          <ChevronRightIcon className="w-8 h-8" />
                        </button>
                      }
                      maxDate={new Date()}
                      prevLabel={
                        <button className="custom-prev-button flex justify-center items-center">
                          <ChevronLeftIcon className="w-8 h-8" />
                        </button>
                      }
                      date={startDate ? new Date(startDate) : new Date()}
                      navigationLabel={({ date }) => (
                        <button
                          style={{ cursor: 'default', pointerEvents: 'none' }}
                          className="text-base"
                        >
                          {date.toLocaleDateString('en-US', { year: 'numeric', month: 'long' })}
                        </button>
                      )}
                    />
                  </div>
                </div>
              )}
            </div>
            <Link
              to={userData?.slug ? `/${userData?.slug}/challenges/create-new-challenges?page=details&newchallenge=true` : '/challenges/create-new-challenges?page=details&newchallenge=true'}
              className="font-medium px-5 py-2 bg-shoorah-active text-white rounded-full w-full sm:w-auto xl:text-[16px] text-[14px]"
            >
              Create New Challenge
            </Link>
          </div>
        </div>

        {isSuperAndSubAdmin() && (
          <div className="grid md:grid-cols-3 grid-cols-1 h-auto gap-4 mt-5">
            {subAdminStatusCards.map((item, index) => (
              <React.Fragment key={index}>{item}</React.Fragment>
            ))}
          </div>
        )}
        
        {isCopanySuperOrSubAdmin() && (
          <div className="grid md:grid-cols-4 grid-cols-1 h-auto gap-4 mt-5">
            {B2BAdminStatusCards.map((item, index) => (
              <React.Fragment key={index}>{item}</React.Fragment>
            ))}
          </div>
        )}

        <div className="lg:mt-8 flex flex-col">
          <ChallengesCard
            title="Active Challenges"
            onViewAllTap={() => navigate(userData?.slug ? `/${userData?.slug}/challenges/view-challenges?type=active` : '/challenges/view-challenges?type=active')}
            dataList={challengesList?.activeChallenges || []}
            
          />
          <ChallengesCard
            title="Challenges"
            onViewAllTap={() => navigate(userData?.slug ? `/${userData?.slug}/challenges/view-challenges?type=challenges` : '/challenges/view-challenges?type=challenges')}
            dataList={challengesList?.allChallenges || []}
            preview={true}
          />
          <ChallengesCard
            title="Challenge Templates"
            onViewAllTap={() => navigate(userData?.slug ? `/${userData?.slug}/challenges/view-challenges?type=templates` : '/challenges/view-challenges?type=templates')}
            dataList={challengesList?.allTemplates || []}
            preview={true}
          />
        </div>
      </div>
    </>
  );
}

export default Challenges;